import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ItalicIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "9"}
      height={height || "14"}
      viewBox="0 0 9 14"
    >
      <path
        id="Path_10403"
        data-name="Path 10403"
        d="M9-15.75a.5.5,0,0,0-.5-.5h-5a.5.5,0,0,0-.5.5v.485a.5.5,0,0,0,.5.5H4.961L2.461-3.808H.5a.5.5,0,0,0-.5.5v.558a.5.5,0,0,0,.5.5h5a.5.5,0,0,0,.5-.5v-.558a.5.5,0,0,0-.5-.5H4.039l2.5-10.957H8.5a.5.5,0,0,0,.5-.5Z"
        transform="translate(0 16.25)"
        fill={color || "#333"}
      />
    </svg>
  );
}
